import * as defaultImport from "@splunk/react-icons/Magnifier";
export * from "@splunk/react-icons/Magnifier";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
